import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAppConfig } from '../../config/config';
import { prepareAuthHeaders } from '../../config/authConfig';
import { SummerExternalColor } from '../../types/domainTypes';

export const temperatureDataApi = createApi({
  reducerPath: 'temperatureDataApi',
  baseQuery: fetchBaseQuery({ prepareHeaders: prepareAuthHeaders }),
  tagTypes: ['TemperatureData'],
  endpoints: (builder) => ({
    getTemperatureData: builder.query<SummerExternalColor[], null>({
      query: () => {
        const url = `${getAppConfig().apiUrl}/TemperatureData`;

        return { url: url, method: 'GET' };
      },
    }),
  }),
});

export const { useGetTemperatureDataQuery, util } = temperatureDataApi;
